// extracted by mini-css-extract-plugin
export default {"table":"sales-section_table__wrb6n","labelCell":"sales-section_labelCell__TcLbk"};